import nxModule from 'nxModule';
import ParameterizedLocalCache from 'shared/utils/parameterized-local-cache';

nxModule.factory('printBackgroundCache', (http, CacheFactory, config) =>
  new ParameterizedLocalCache({
    provider: (parameters) => http.get(`/print/${parameters.printCode}/background-image`, {
      params: parameters.params
    }),
    cacheFactory: CacheFactory,
    cacheTime: config.cache.printBackgroundCache,
    cacheName: 'printBackgroundFilesCache'
  })
);
